module.exports = __webpack_public_path__ + "static/img/jsdffx.5cfa2a89.png";